/**
 * Коди помилок входу, реєстрації й режиму спостерігача (контракт AUTH): тексти прототипу v4 — no_account … password_short (Development);
 * решта — коди продуктиву (одна загальна помилка входу invalid_credentials — рішення 5 етапу 9: Production не каже, чи є обліковий запис;
 * двоетапна перевірка й підключення застосунку автентифікації, вимкнені способи входу, обмеження спроб); невідомий код — загальна помилка.
 */
const KNOWN = new Set([
  'no_account', 'bad_password', 'invalid_credentials', 'locked', 'name_required', 'email_invalid', 'email_taken', 'password_short', 'mfa_required', 'mfa_invalid',
  'mfa_setup_required', 'mfa_enrol_expired', 'mfa_code_short', 'method_disabled', 'registration_disabled', 'provider_unavailable', 'observer_disabled',
  'person_not_found', 'read_only',
]);
/** Забагато спроб входу (429 без власного коду). */
const THROTTLED = new Set(['http_429', 'too_many_attempts', 'too_many_requests']);

/** Ключ i18n тексту помилки за кодом відповіді сервера (problem+json `code`) чи перевірки форми. Чиста функція. */
export const authErrorKey = (code: string | null | undefined): string =>
  `auth.errors.${code && KNOWN.has(code) ? code : code && THROTTLED.has(code) ? 'throttled' : 'failed'}`;
